import axios from 'axios';

import type { PrivateClassLesson } from '../interfaces';
import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class PrivateClassLessonsDao {
  static async getPrivateClassLessons(
    env: Environment,
    contactId: string,
    lessonTrackUuid: string,
    forTeacher: boolean = false,
    showFreeFormLesson: boolean = false
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<PrivateClassLesson[]>(
      `${url}/v1/liveclasslessons`,
      {
        params: { contactId, lessonTrackUuid, forTeacher, showFreeFormLesson },
      }
    );
    return data;
  }
}
